module.exports = __webpack_public_path__ + "img/pension.781d73c2.svg";